import axios from "@/api/axios";

const getSalesAllList = (data) => {
    return axios
        .post('/admin/sales/sales-all-list', {sales: data})
        .then(response => response.data)
}

const getSalesList = (page, limit) => {
    return axios
        .post('/admin/sales/sales-list', {page: page, limit: limit})
        .then(response => response.data)
}

const getSaleInfo = (data) => {
    return axios
        .post('/admin/sales/sales-info', { sales: data })
        .then(response => response.data)
}

const createSale = (data) => {
    return axios
        .post('/admin/sales/create-sale', {sale: data})
        .then(response => response.data)
}

const editSale = (data) => {
    return axios
        .post('/admin/sales/edit-sale', { sale: data })
        .then(response => response.data)
}

const getSalesNodeal = (data) => {
    return axios
        .post('/admin/sales/sales-nodeal', {sales: data})
        .then(response => response.data)
}

const getSalesOrganizations = (data) => {
    return axios
        .post('/admin/sales/sales-organizations', {sales: data})
        .then(response => response.data)
}

const createSalePart = (data) => {
    return axios
        .post('/admin/sales/create-sale-part', {sale: data})
        .then(response => response.data)
}

const buyDelete = (data) => {
    return axios
        .post('/admin/sales/delete-sale', {sale: data})
        .then(response => response.data)
}

const getRentalsTypes = (data) => {
    return axios
        .post('/admin/sales/rentals-types', {sale: data})
        .then(response => response.data)
}

const createRental = (data) => {
    return axios
        .post('/admin/sales/create-rental', {sale: data})
        .then(response => response.data)
}

const printSale = (data) => {
    return axios
        .post('/admin/sales/print-sale', {sale: data})
        .then(response => response.data)
}

const saleHistory = (data) => {
    return axios
        .post('/admin/sales/sale-history', {sale: data})
        .then(response => response.data)
}

const salePromo = (data) => {
    return axios
        .post('/admin/sales/sale-promo', {sale: data})
        .then(response => response.data)
}

const getContractList = (data) => {
    return axios
        .post('/admin/sales/contract-list', {sale: data})
        .then(response => response.data)
}

const getNomenclatureFull = (data) => {
    return axios
        .post('/admin/sales/full-nomenclature', {sale: data})
        .then(response => response.data)
}

export default {
    getSalesAllList,
    getSalesList,
    getSaleInfo,
    createSale,
    editSale,
    getSalesNodeal,
    getSalesOrganizations,
    createSalePart,
    buyDelete,
    getRentalsTypes,
    createRental,
    printSale,
    saleHistory,
    salePromo,
    getContractList,
    getNomenclatureFull
}